import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import type { UAPPlacementComponentProps } from '../@types';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getBusinessNameWithAdLabelStyles } from '../styles';

const adsIconImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAotJREFUWIW9lrFWGlEQhr+5cEzLG2R9AxBTpMM6jWBSUAlPID4B+ATKE0gqz4mH3Sq1WOWc6EregE2bxjUdJjApUBS4wC4L+bu9d/b+387cnTMCQNtvIBwBIHT4O2zy6V2H/yCh7VcQzi1bHaRfpfg+2CSAwcihfUsL6FYPzz/H++ZsCkBw/XsgEyF0Ixkx0cxhUxkxlrUAzD5pKaC0ZjmorBNEcH2dXNEaxd3m+Pmi6/Bm4IFk55zQgseTVUtjgHBiRc2PiedyLqC0m0OpgsyaJMyIAQmXhwEH+Ralne2lIJd+Iw6I7Q5EBTm2gqSoo1tXXPqN9QJ4XQfPP8W9PXwCOaMvewg2I4cUdVy/N45PBOB1HXTYRamBtMaHlnMBxfwJfbNt/WPAGcXPB4lTgpd+ITJZ43Iu4CBfXQUkGkAxFzylOgDtEJqmNS4OyJfvWQDBveuBvvoiKVDauY4EtkwXXYc36oHae8hguBe9BG2/gevf4/o9zrvR2nc5FyCyx3SveVZKTqMDjOaFDOCQGSy82ZaX5/Qayax2CcGe0ml5NwVUryZL/EpDPUvHAIgu76YAqTqqBVBLgHbANPiYv14vQNuvYORwqXEpP77k6wFo+xVE6qAOGs14PQDe7RFqaqMaxzNOBqAmi3vXQ+cZE4BUFhknA5jXWEadskFp93PUk9KgEWfChQpRzvhtmlRz0eaLF4CpoVSGWcCWunAmNoHxa4BJqdTwbgFxAAcICc0xw0EVY06fmkqI0uLxsUk52Zg+O5RapZVxXb/eveWXPKz6xdNKY0/tpPp/XkryYefnOoyftWwoDUErSdO8GEDUNjiA0uLBbMf5pVZRGkwTHWYR9kE7qHSS3Oq4+gfBZCnchNpiDQAAAABJRU5ErkJggg==';

export const BusinessNameWithAdsLabelImpl = ({
  businessName,
  showAdsLabel,
  showAdsIcon,
  i18n,
  rootClassName,
  classes,
  isAdPreviewRefreshEnabled,
}: UAPPlacementComponentProps) => (
  <div className={classnames(isAdPreviewRefreshEnabled ? classes.businuessNameRefreshed : classes.businessNameWithAdsLabelRoot, rootClassName)}>
    {
      showAdsLabel && <span className="ads-label">{i18n.getString(_TL_('Ad'))}</span>
    }
    {
      businessName && <span className="business-name">{businessName}</span>
    }
    {
      showAdsIcon && <img className="ads-icon" alt="icon" src={adsIconImg} />
    }
  </div>
);

BusinessNameWithAdsLabelImpl.propTypes = {
  businessName: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  showAdsLabel: PropTypes.bool,
  rootClassName: PropTypes.string,
  classes: PropTypes.shape({
    businessNameWithAdsLabelRoot: PropTypes.string,
  }).isRequired,
  showAdsIcon: PropTypes.bool,
};

BusinessNameWithAdsLabelImpl.defaultProps = {
  businessName: undefined,
  rootClassName: undefined,
  showAdsLabel: false,
  showAdsIcon: false,
};

export const BusinessNameWithAdsLabel = withUAPLThemedStyles(
  BusinessNameWithAdsLabelImpl,
  getBusinessNameWithAdLabelStyles,
  { componentName: 'BusinessNameWithAdsLabel ' }
);
